import { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { actions, Errors, Form } from 'forms/rrf';
import SectionTitle from '../../../common/section-title';
import PageTitle from '../../../common/page-title';
import ArrowButton from '../../../common/button-arrow';
import Number from '../../../common/form/spinner';
import { getExpiry, saveExpiry, viewExpire } from '../../../../actions/points';

class PointsExpiry extends Component {
  state = {
    day: '',
    month: ''
  };

  onPointsExpiryClick = () => {
    this.props.dispatch(viewExpire());
  };

  onSubmit = (payload) => {
    this.props.dispatch(actions.submitFields('deep.points_expiry', saveExpiry(payload)));
  };

  UNSAFE_componentWillMount() {
    this.props.dispatch(getExpiry());
  }

  render() {
    return (
      <div className="container-fluid">
        <PageTitle>
          Points expiry
        </PageTitle>
        <Col md={12}>
          <Row>
            <ArrowButton
              arrow={false}
              className="float-right"
              onClick={this.onPointsExpiryClick}
              submit={false}
            >
              Download points expiry
            </ArrowButton>
          </Row>
        </Col>
        <SectionTitle>
          Points expiry settings
        </SectionTitle>
        <Col md={12}>
          <Row>
            <Form model="deep.points_expiry" onSubmit={this.onSubmit}>

              <Errors className="errors" model="deep.points_expiry"/>

              <Col md={12}>
                <Row>
                  <FormGroup controlId="month">
                    Month to expiry:
                    {' '}
                    <Number
                      min={1}
                      model={'deep.points_expiry.month'}
                      value={this.props.month}
                    />
                  </FormGroup>
                </Row>
              </Col>
              <Col md={12}>
                <Row>
                  <FormGroup controlId="day">
                    Day of month to run expiry:
                    {' '}
                    <Number
                      max={28}
                      min={1}
                      model={'deep.points_expiry.day'}
                      value={this.props.day}
                    />
                  </FormGroup>
                </Row>
              </Col>
              <Col md={12}>
                <Row>
                  <ArrowButton
                    className="float-right"
                    color="red"
                  >
                    save
                  </ArrowButton>
                </Row>
              </Col>
            </Form>
          </Row>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  day: (state.points.point_expiry.attributes && state.points.point_expiry.attributes.day) || 1,
  month: (state.points.point_expiry.attributes && state.points.point_expiry.attributes.month) || 1,
});

export default connect(mapStateToProps)(PointsExpiry);
